<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
      class="add-new-data-sidebar items-no-padding" spacer v-esc="escape" v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Fiyat Listesi" : "Fiyat Listesi Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <form data-vv-scope="form-1" @keyup.enter="submitData">
          <div class="px-6">

            <vs-input id="name" name="Fiyat Listesi Adı" v-validate="'required|min:2|max:40'" v-model="newList.name"
              class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Fiyat Listesi Adı" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.Fiyat Listesi Adı')">{{ errors.first('form-1.Fiyat Listesi Adı')}}</span>
              <label>Kopyalanacak Liste Seçimi</label>
        <v-select label-placeholder="Liste Seçimi" v-model="selectedList" itemid="id" label="name" class="w-full" v-if="$isCenterBranch() || $isRegionalCenterBranch()"
            placeholder="Liste Seçimi" :options="$currentUser.branch.id == 1 ? data3 : []" :clearable="true">
          </v-select>

          </div>
        </form>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </vs-sidebar>
  </template>

  <script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import {
        createProductPriceList,
        updateProductPriceList
    } from '@/api/BranchProductPrice';
import { th } from 'vuejs-datepicker/src/locale';
    export default {
      props: {
        isSidebarActive: {
          type: Boolean,
          required: true
        },
        data: {
          type: Object,
          default: () => {},
        },
        data3: {
        type: Array,
        default: () => []
      }
      },
      data() {

        return {
          newList: {},
          selectedList:null,
          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
        }
      },
      computed: {
        isSidebarActiveLocal: {
          get() {
            return this.isSidebarActive
          },
          set(val) {
            if (!val) {
              this.$emit('closeSidebar')
              this.$validator.reset()
              this.initValues()
            }
          }
        }
      },
      methods: {
        escape(){
          if(this.isSidebarActiveLocal = true) this.isSidebarActiveLocal = false;
        },
        initValues() {
          this.newList = {};
        },
        submitData: async function () {
          let checker;
          checker = await this.$validator.validateAll('form-1');
          if (checker) {
            if (this.newList.id) {
                updateProductPriceList(this.newList).then(res => {
                if (res && res.status == 200) {

                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Fiyat Listesi Güncelleme Başarılı ! '
                    });
                    this.$emit('refreshTable');
                    this.$emit('closeSidebar');
                    this.initValues();
                    this.$validator.reset();

                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata : ' + res.status,
                    text: 'Fiyat Listesi Güncelleme Başarısız ! '
                  });
                }
              }).catch(() => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: 'Sunucu Bağlantı Hatası ! '
                });
              });
            } else {
              this.newList.id = 0;
              if(this.selectedList==null){
                this.newList.listId=0
              }else{
                this.newList.listId=this.selectedList.id
              }

              createProductPriceList(this.newList).then(res => {
                if (res && res.status == 200) {
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'Fiyat Listesi Ekleme Başarılı ! '
                    });
                    this.$emit('closeSidebar');
                    this.$emit('refreshTable');
                    this.initValues();
                    this.$validator.reset();

                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata !',
                    text: 'Fiyat Listesi Ekleme Başarısız ! '
                  });
                }
              }).catch(() => {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: 'Sunucu Bağlantı Hatası ! '
                });
              });
            }
          }
        },
      },
      components: {
        VuePerfectScrollbar
      },
      watch: {
        isSidebarActive: function (val) {
          if (!val) return
          if (Object.entries(this.data).length === 0) {
            this.initValues();
            this.$validator.reset();
          } else {
            Object.assign(this.newList, this.data); //Şurda.
          }
        },
      },
      mounted: function () {},
      created: async function () {}
    }

  </script>

  <style lang="scss" scoped>
    .style-chooser .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: red;
      text-transform: lowercase;
      font-variant: small-caps;
    }

    .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
        z-index: 52010;
      }

      ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;

        .img-upload {
          margin-top: 2rem;

          .con-img-upload {
            padding: 0;
          }

          .con-input-upload {
            width: 100%;
            margin: 0;
          }
        }
      }
    }

    .tabPager {
      background-color: darkgreen;
      border-radius: 50%;
    }

  </style>

  <style>
  .vs__dropdown-menu {
      max-height: 25vh !important;
      overflow-x: hidden !important;
      overflow-y: scroll !important;
    }
  </style>
